import _ from 'lodash'
import { Fragment } from 'react'

export function PriceRange(d: number[], supClassName?: string) {
  if (_.isEmpty(d)) {
    return <></>
  }
  if (_.size(d) === 1) {
    return <><sup className={supClassName}>$</sup>{d[0]}k+</>
  }
  return _.map(d, (x, idx) =>
    <Fragment key={`price-${idx}`}>
      {idx > 0 && <span> - </span>}
      <sup className={supClassName}>$</sup>{x}k
    </Fragment>
  )
}